

















































import Vue from 'vue'

type actions = 'editUser' | 'deleteUser' | 'restoreUser' | 'hardDeleteUser'

export default Vue.extend({
  name: 'UserActions.vue',
  props: {
    item: {},
    loggedInUserObject: {}
  },
  methods: {
    clickEvent (event: actions) {
      const user = this.item
      this.$emit('clickEvent', { event, user })
    }
  }
})
